<script setup lang="ts">
import { useLocale } from '@/composables/useLocale'
import { Button, Tooltip } from 'ant-design-vue'

const { toggleLocale, currentLocale: locale } = useLocale()
</script>

<template>
 <Tooltip :title="locale === 'vi' ? 'Switch to English' : 'Đổi sang Tiếng Việt'">
  <Button type="text" class="crm-header-control" @click="toggleLocale">
   {{ locale === 'vi' ? 'EN' : 'VI' }}
  </Button>
 </Tooltip>
</template>
